import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { MenuMealCardsModal } from 'src/componentsV2/MenuMealCardsModal/MenuMealCardsModal'
import { useIsMobile } from 'src/hooks/useIsMobile'
import { setNutritionInfoButtonVisibility } from 'src/redux-api-bridge/mealDetail/actions'
import {
  trackFreePremiumOverlayClicked,
  trackFreePremiumOverlayClosed,
  trackFreePremiumOverlayViewed
} from 'src/utils/tracking'
import { FreePremiumMealsModalOutOfStock } from '../FreePremiumMealsModalOutOfStock/FreePremiumMealsModalOutOfStock'
import { useFreePremiumMeals } from '../useFreePremiumMeals'
import { getFreePremiumMealsModalText } from '../utils'
import { FreePremiumMealsBottomSheetModal } from './FreePremiumMealsBottomSheetModal/FreePremiumMealsBottomSheetModal'
import './FreePremiumMealsModal.scss'

interface FreePremiumMealsModalProps {
  isOpen: boolean
  onCloseClick: () => void
}

export const FreePremiumMealsModal = ({
  isOpen,
  onCloseClick
}: FreePremiumMealsModalProps) => {
  const isMobile = useIsMobile()
  const dispatch = useDispatch()

  const {
    addFreePremiumMeal,
    removeFreePremiumMeal,
    clearAllFreePremiumMeals,
    meals,
    allFreePremiumMealsAdded,
    freePremiumMealsQty
  } = useFreePremiumMeals()

  const onClose = () => {
    trackFreePremiumOverlayClicked('X')
    onCloseClick()
  }

  const discardChanges = () => {
    trackFreePremiumOverlayClicked('Not now')
    clearAllFreePremiumMeals()
    onCloseClick()
  }

  const onConfirm = () => {
    trackFreePremiumOverlayClicked('Add to my order')
    onCloseClick()
  }

  const mealsOutOfStock = meals.length === 0

  const showOutOfStockModal = mealsOutOfStock && isOpen
  const showMobileModal = !mealsOutOfStock && isMobile && isOpen
  const showDesktopkModal = !mealsOutOfStock && !isMobile && isOpen

  const modalTexts = getFreePremiumMealsModalText()
  const description =
    freePremiumMealsQty > 1
      ? modalTexts.descriptionPlural.replace(
          '{qty}',
          freePremiumMealsQty.toString()
        )
      : modalTexts.description

  useEffect(() => {
    dispatch(setNutritionInfoButtonVisibility(!isOpen))
    if (isOpen) {
      trackFreePremiumOverlayViewed()
    } else {
      trackFreePremiumOverlayClosed()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  return (
    <>
      {showOutOfStockModal && (
        <FreePremiumMealsModalOutOfStock
          isOpen={isOpen}
          onCloseClick={onCloseClick}
          title={modalTexts.titleOutOfStock}
          description={modalTexts.descriptionOutOfStock}
          cta={modalTexts.ctaOutOfStock}
        />
      )}
      {showMobileModal && (
        <FreePremiumMealsBottomSheetModal
          isOpen={isOpen}
          onRequestClose={onClose}
          title={modalTexts.title}
          subtitle={description}
          cancelText={modalTexts.ctaCancel}
          confirmText={modalTexts.ctaConfirm}
          meals={meals}
          onAddItem={addFreePremiumMeal}
          onClickMeal={() => {}}
          onRemoveItem={removeFreePremiumMeal}
          onDiscardChangesBtnClicked={discardChanges}
          freeMealsCompleted={allFreePremiumMealsAdded}
          onConfirm={onConfirm}
        />
      )}
      {showDesktopkModal && (
        <div>
          <MenuMealCardsModal
            isOpen={isOpen}
            meals={meals}
            title={modalTexts.title}
            subtitle={description}
            onAddItem={addFreePremiumMeal}
            onRemoveItem={removeFreePremiumMeal}
            handleClose={onClose}
            primaryButtonClick={discardChanges}
            secondaryButtonClick={onConfirm}
            disableSecondaryBtn={!allFreePremiumMealsAdded}
            disableMealsActions={allFreePremiumMealsAdded}
            withCloseIcon
            primaryButtonText={modalTexts.ctaCancel}
            secondaryButtonText={modalTexts.ctaConfirm}
            crossSellingModal={false}
            onClickMeal={() => {}}
          />
        </div>
      )}
    </>
  )
}
